<script setup lang="ts">
// @ts-expect-error Missing types
import type { Trigger } from 'vue-smart-suggest';
// @ts-expect-error Missing types
import { SmartSuggest } from 'vue-smart-suggest';

import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from '@/components/ui/dialog';
import { Textarea } from '@/components/ui/textarea';
import { onMounted, reactive, watch } from 'vue';
import type { PromptConfig } from '@/types/edit/PromptConfig.ts';

const props = defineProps<{
    outputFormatInstruction: string;
    showChoiceFormatWarning: boolean;
    promptConfigs: Record<PromptConfig['id'], PromptConfig>;
    triggers: Trigger[];
    disabled: boolean;
}>();

const emit = defineEmits<{
    change: [outputFormatInstruction: string];
}>();

interface ComponentState {
    outputFormatInstructionCopy: string;
    isOpen: boolean;
}

const state: ComponentState = reactive({
    outputFormatInstructionCopy: '',
    isOpen: false,
});

/* region Event handlers */
const save = () => {
    emit('change', state.outputFormatInstructionCopy);
    state.isOpen = false;
};
/* endregion Event handlers */

/* region Lifecycle */
onMounted(() => {
    state.outputFormatInstructionCopy = props.outputFormatInstruction;
});

watch(
    () => props.outputFormatInstruction,
    () => {
        state.outputFormatInstructionCopy = props.outputFormatInstruction;
    },
);
/* endregion Lifecycle */
</script>

<template>
    <Dialog v-model:open="state.isOpen">
        <DialogTrigger as-child>
            <Button variant="secondary" :disabled="disabled"> Edit format instruction </Button>
        </DialogTrigger>
        <DialogContent class="w-[calc(80vw)] max-w-[800px]">
            <DialogHeader>
                <DialogTitle>Edit prompt output format</DialogTitle>
            </DialogHeader>
            <SmartSuggest :triggers="triggers">
                <Textarea
                    v-model="state.outputFormatInstructionCopy"
                    class="custom-scrollbar text-md h-[240px] font-mono dark:bg-gray-900"
                    :disabled="disabled"
                    spellcheck="false"
                />
            </SmartSuggest>
            <DialogDescription v-if="showChoiceFormatWarning">
                <p class="mb-2">
                    <strong>Note:</strong> When using the "Choice" output type. Make sure to include
                    instructions to format the output as a JSON array of objects containing
                    following fields: "title", "description" and optionally "smallTitle".
                </p>
                <p>These fields may include HTML.</p>
            </DialogDescription>
            <DialogFooter>
                <Button type="submit" @click="save"> Save changes </Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>
